<!--Create Devops Action Dialog Title-->
<h2>Create Devops Action</h2>
<form #createActionForm="ngForm" novalidate>
    <mat-dialog-content>
        <!--Dialog Content-->
        <div *ngIf="!createDevOpsActionResponse">
            <!-- Action Name -->
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Action Name</mat-label>
                    <mat-select aria-required="true" required [(ngModel)]="selectedDevOpsActionAndParameter"
                        name="actionName" (selectionChange)="onActionNameChanged()">
                        <mat-option *ngFor="let item of createDevOpsActionDialogData.devOpsActionsAndParameters"
                            [value]="item" [disabled]="!item.isEnabled">
                            <span>{{item.actionName}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- CustomerId -->
            <div *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.actionScope == 'Customer'">
                <mat-form-field class="form-field">
                    <mat-label>Customer Id</mat-label>
                    <mat-select aria-required="true" required [(ngModel)]="createDevOpsActionRequest.customerId"
                        name="customerId">
                        <mat-option *ngFor="let item of cloudCutomers" [value]="item.customerId">
                            <span>{{item.name}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- AccountId -->
            <div *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.actionScope == 'Account'">
                <mat-form-field class="form-field">
                    <mat-label>Account Id</mat-label>
                    <mat-select aria-required="true" required [(ngModel)]="createDevOpsActionRequest.accountId"
                        name="accountId">
                        <mat-option *ngFor="let item of cloudAccounts" [value]="item.accountId">
                            <span>{{item.accountId}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- EnvironmentId -->
            <div
                *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.actionScope == 'Environment'">
                <mat-form-field class="form-field">
                    <mat-label>Environment Id</mat-label>
                    <mat-select aria-required="true" required [(ngModel)]="createDevOpsActionRequest.environmentId"
                        name="environmentId">
                        <mat-option *ngFor="let item of cloudEnvironments" [value]="item.environmentId">
                            <span>{{item.environmentId}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- Region -->
            <div *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.actionScope == 'Region'">
                <mat-form-field class="form-field">
                    <mat-label>Region</mat-label>
                    <mat-select aria-required="true" required [(ngModel)]="createDevOpsActionRequest.region"
                        name="region">
                        <mat-option *ngFor="let item of supportedRegions" [value]="item">
                            <span>{{item}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Schedule Expression OR Trigger Time-->
            <div *ngIf="selectedDevOpsActionAndParameter">
                <mat-form-field class="form-field">
                    <mat-label>Trigger Type: Schedule Expression Or Trigger Time</mat-label>
                    <mat-select aria-required="true" required [(ngModel)]="selectedTriggerType" name="triggerType"
                        (selectionChange)="onTriggerTypeChanged()">
                        <mat-option *ngFor="let item of triggerTypes" [value]="item">
                            <span>{{item}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- Schedule Expression -->
                <div *ngIf="selectedTriggerType && selectedTriggerType == 'Schedule Expression'">
                    <mat-form-field class="form-field">
                        <mat-label>Schedule Expression</mat-label>
                        <input aria-required="true" required matInput
                            [(ngModel)]="createDevOpsActionRequest.scheduleExpression" name="scheduleExpression" 
                            (input)="onScheduleExpressionChanged()"/>
                        <mat-hint>{{scheduleExpressionHint}}</mat-hint>
                    </mat-form-field>
                </div>
                <div *ngIf="selectedTriggerType && selectedTriggerType == 'Trigger Date Time'">
                    <!-- Trigger Date -->
                    <mat-form-field class="form-field">
                        <mat-label>Trigger Date</mat-label>
                        <input aria-required="true" required matInput readonly [matDatepicker]="picker"
                            [(ngModel)]="selectedTriggerDate" name="triggerDate" (dateInput)="onDateChanged($event)"
                            (dateChange)="onDateChanged($event)" />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <!-- Trigger Time -->
                    <div>
                        <p style="color: grey; margin-bottom: 0;">Trigger Time (in 24hr)</p>
                        <div style="display: flex; flex-direction: row;">
                            <mat-form-field class="form-field-time">
                                <mat-label>Hours</mat-label>
                                <mat-select aria-required="true" required [(ngModel)]="selectedTriggerTimeHours"
                                    name="triggerTimeHours" (selectionChange)="onTimeChanged()">
                                    <mat-option *ngFor="let hour of hours" [value]="hour">
                                        <span>{{hour}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="form-field-time">
                                <mat-label>Minutes</mat-label>
                                <mat-select aria-required="true" required [(ngModel)]="selectedTriggerTimeMinute"
                                    name="triggerTimeMinute" (selectionChange)="onTimeChanged()">
                                    <mat-option *ngFor="let minute of minutes" [value]="minute">
                                        <span>{{minute}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="form-field-time">
                                <mat-label>Seconds</mat-label>
                                <mat-select aria-required="true" required [(ngModel)]="selectedTriggerTimeSecond"
                                    name="triggerTimeSecond" (selectionChange)="onTimeChanged()">
                                    <mat-option *ngFor="let second of seconds" [value]="second">
                                        <span>{{second}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- Date Time when parsed to json with time zone information -->
                    <p *ngIf="createDevOpsActionRequest?.triggerTime">Trigger Date Time in UTC:
                        {{createDevOpsActionRequest?.triggerTime | json}}</p>
                </div>
            </div>

            <!-- Parameters-->
            <div *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.isParametersSupported">
                <!-- Available Named Parameters -->
                <div *ngIf="selectedDevOpsActionAndParameter.parameters">
                    <mat-form-field class="form-field">
                        <mat-label>Parameters</mat-label>
                        <mat-select aria-required="true" required [(ngModel)]="selectedDevOpsParameterArray"
                            name="selectedParameter" (selectionChange)="onDevOpsParameterArrayChanged()">
                            <mat-option *ngFor="let parameter of selectedDevOpsActionAndParameter.parameters"
                                [value]="parameter.value">
                                <span>{{parameter.key}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="selectedActionParameterArray">
                    <div *ngFor="let devOpsParameter of selectedActionParameterArray">
                        <section *ngIf="devOpsParameter.isBoolean">
                            <mat-checkbox [(ngModel)]="devOpsParameter.value" name="devOpsBooleanParameter">
                                {{devOpsParameter.name}}</mat-checkbox>
                        </section>
                        <mat-form-field *ngIf="devOpsParameter.isString" class="form-field">
                            <mat-label>{{devOpsParameter.name}}</mat-label>
                            <input aria-required="true" required matInput [(ngModel)]="devOpsParameter.value"
                                name="devOpsStringParameter" />
                        </mat-form-field>
                        <mat-form-field *ngIf="devOpsParameter.isNumber" class="form-field">
                            <mat-label>{{devOpsParameter.name}}</mat-label>
                            <input aria-required="true" required matInput type="number"
                                [(ngModel)]="devOpsParameter.value" name="devOpsNumberParameter" />
                        </mat-form-field>
                        <mat-form-field *ngIf="devOpsParameter.valueCollection" class="form-field">
                            <mat-label>{{devOpsParameter.name}}</mat-label>
                            <mat-select aria-required="true" required [(ngModel)]="devOpsParameter.value"
                                name="devOpsParameterSelectedCollectionValue">
                                <mat-option *ngFor="let val of devOpsParameter.valueCollection" [value]="val">
                                    <span>{{val}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="createDevOpsActionResponse">
            <label>EventRule Id: {{createDevOpsActionResponse.eventRuleId}}</label> <br />
            <label *ngIf="createDevOpsActionResponse.error">Error: {{createDevOpsActionResponse.error}}</label>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <!--Dialog action buttons-->
        <button class="dialog-button" mat-raised-button color="primary" (click)="save()"
            [disabled]="createActionForm.form.invalid || isSaving || !this.selectedDevOpsActionAndParameter"
            *ngIf="!createDevOpsActionResponse">
            <span *ngIf="!isSaving">Save</span>
            <span *ngIf="isSaving">Saving...</span>
        </button>
        <button class="dialog-button" mat-raised-button [disabled]="isSaving"
            (click)="close()">Cancel</button>
    </mat-dialog-actions>
</form>